// extracted by mini-css-extract-plugin
export default {"tabs":"BpsTabs_tabs__ABOG7","tab":"BpsTabs_tab__UEQVf","active":"BpsTabs_active__a+DN+"};